<template>
  <v-card>
    <v-card-title class="align-start">
      <span class="font-weight-semibold">Statistics Data</span>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-subtitle class="mb-8 mt-n5">
      <span class="font-weight-semibold text--primary me-1">Total data to run </span>
      <span>😎 this month</span>
    </v-card-subtitle>

    <v-card-text>
      <v-row>
        <v-col
          v-for="data in statisticsData"
          :key="data.title"
          class="d-flex align-center"
        >
          <v-avatar
            size="44"
            :color="resolveStatisticsIconVariation (data.title).color"
            rounded
            class="elevation-1"
          >
            <v-icon
              dark
              color="white"
              size="30"
            >
              {{ resolveStatisticsIconVariation (data.title).icon }}
            </v-icon>
          </v-avatar>
          <div class="ms-3">
            <p class="text-xs mb-0">
              {{ data.title }}
            </p>
            <h3 class="text-xl font-weight-semibold">
              {{ data.total }}
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiAccountOutline,
  mdiCurrencyUsd,
  mdiTrendingUp,
  mdiDotsVertical,
  mdiClipboardList,
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiFaceAgent,
  mdiHumanGreeting,
  mdiBedOutline,
  mdiSilverware,
  mdiRunFast,
  mdiCarMultiple,
  mdiDatabasePlus,
  mdiNotePlus,
  mdiPlaylistPlus,
  mdiBoomGate,
  mdiMapMarkerPlus,
  mdiRoomService,
  mdiCashMultiple,
  mdiListStatus,
} from '@mdi/js'

import axios from 'axios'

export default {
  setup() {
    const statisticsData = [
      {
        title: 'Activity',
        total: '0',
      },
      {
        title: 'Hotel',
        total: '0',
      },
      {
        title: 'Restaurant',
        total: '0',
      },
      {
        title: 'Transport',
        total: '0',
      },
      {
        title: 'Entrance',
        total: '0',
      },
    ]

    const resolveStatisticsIconVariation = data => {
      if (data === 'Hotel') return { icon: mdiBedOutline, color: 'primary' }
      if (data === 'Transport') return { icon: mdiCarMultiple, color: 'success' }
      if (data === 'Activity') return { icon: mdiRunFast, color: 'warning' }
      if (data === 'Restaurant') return { icon: mdiSilverware, color: 'info' }
      if (data === 'Entrance') return { icon: mdiBoomGate, color: 'primary' }

      return { icon: mdiAccountOutline, color: 'success' }
    }

    return {
      statisticsData,
      resolveStatisticsIconVariation,

      // icons
      icons: {
        mdiDotsVertical,
        mdiTrendingUp,
        mdiAccountOutline,
        mdiCurrencyUsd,
        mdiClipboardList,
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiFaceAgent,
        mdiHumanGreeting,
        mdiBedOutline,
        mdiSilverware,
        mdiRunFast,
        mdiCarMultiple,
        mdiDatabasePlus,
        mdiNotePlus,
        mdiPlaylistPlus,
        mdiBoomGate,
        mdiMapMarkerPlus,
        mdiRoomService,
        mdiCashMultiple,
        mdiListStatus,
      },
    }
  },
  data() {
    return {
      statisticsData: [],
    }
  },
  mounted() {
    this.getDataRun()
  },
  methods: {
    getDataRun() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/getDataRun').then(response => {
        // this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dialogstatus = false
        this.statisticsData = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors

      //  this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
